var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'Branches'
      }
    }
  }, [_vm._v("分店管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-12 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('div', {
    staticClass: "col-12 d-flex items-center"
  }, [_c('b-breadcrumb', {
    staticClass: "mb-2 p-0",
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.isShow ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "上層分店",
      "label-for": "parent_id"
    }
  }, [_c('b-breadcrumb', {
    staticClass: "mb-0 p-0",
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1) : _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "上層分店",
      "label-for": "parent_id"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "parent_id",
      "options": _vm.branchOptions,
      "disabled": !_vm.isEdit || _vm.isShow
    },
    model: {
      value: _vm.form.parent_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "parent_id", $$v);
      },
      expression: "form.parent_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "類型",
      "label-for": "branch_type"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "parent_id",
      "state": _vm.v$.form.branch_type.$error ? false : null,
      "options": _vm.branchTypes,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.branch_type,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "branch_type", $$v);
      },
      expression: "state.form.branch_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.branch_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "state": _vm.v$.form.name.$error ? false : null,
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.state.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "name", $$v);
      },
      expression: "state.form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "編號代碼",
      "label-for": "branch_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "branch_code",
      "type": "text",
      "state": _vm.v$.form.branch_code.$error ? false : null,
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.state.form.branch_code,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "branch_code", $$v);
      },
      expression: "state.form.branch_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.branch_code.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "外部編號",
      "label-for": "outer_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "outer_code",
      "type": "text",
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "outer_code", $$v);
      },
      expression: "form.outer_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序",
      "label-for": "order"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "order",
      "type": "number",
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "status",
      "options": _vm.branchStatuses,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols-lg": "2",
      "label": "地址",
      "label-for": "location_address",
      "role": "tw-city-selector",
      "data-bootstrap-style": "",
      "data-has-zipcode": ""
    }
  }, [_c('div', {
    staticClass: "d-flex w-100 city-selector-set-has-value"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.location_city,
      expression: "form.location_city"
    }],
    staticClass: "form-control form-control-sm county",
    attrs: {
      "readonly": _vm.isShow,
      "disabled": _vm.state.form.branch_type !== 'shop'
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "location_city", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.location_district,
      expression: "form.location_district"
    }],
    staticClass: "form-control form-control-sm district ml-2",
    attrs: {
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "location_district", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.handleChangeZipcode]
    }
  }), _c('b-form-input', {
    staticClass: "zipcode ml-2",
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "郵遞區號"
    }
  })], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "location_address",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.location_address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "location_address", $$v);
      },
      expression: "form.location_address"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "電話",
      "label-for": "telephone"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "telephone",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telephone", $$v);
      },
      expression: "form.telephone"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "傳真",
      "label-for": "fax"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "fax",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.fax,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fax", $$v);
      },
      expression: "form.fax"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "信箱",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "email",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "state": _vm.v$.form.email.$error ? false : null,
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.state.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "email", $$v);
      },
      expression: "state.form.email"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.email.$error
    }
  }, [_vm._v(" 請輸入正確格式 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "品牌名稱",
      "label-for": "brand"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "brand",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.brand,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "brand", $$v);
      },
      expression: "form.brand"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "營業時間",
      "label-for": "biz_hours"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "biz_hours",
      "rows": "4",
      "disabled": _vm.state.form.branch_type !== 'shop'
    },
    model: {
      value: _vm.form.biz_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "biz_hours", $$v);
      },
      expression: "form.biz_hours"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "緯度",
      "label-for": "lat"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "lat",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.lat,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lat", $$v);
      },
      expression: "form.lat"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "經度",
      "label-for": "long"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "long",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.long,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "long", $$v);
      },
      expression: "form.long"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "GOOGLEMAP",
      "label-for": "map_url"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "map_url",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.map_url,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "map_url", $$v);
      },
      expression: "form.map_url"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分類",
      "label-for": "category"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "category",
      "type": "text",
      "disabled": _vm.state.form.branch_type !== 'shop',
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.category,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "category", $$v);
      },
      expression: "form.category"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "is_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "is_enabled",
      "readonly": _vm.isShow
    },
    model: {
      value: _vm.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_enabled", $$v);
      },
      expression: "form.is_enabled"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.isShow ? '返回' : '取消'))]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [!_vm.isShow ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "確認修改" : "確認新增"))]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }